<template>
	<v-container
		class="fill-height"
		fluid
	>

		<v-row
			align="center"
			justify="center"
		>
			<v-col
				cols="12"
				sm="8"
				md="4"
			>
				<v-card class="elevation-12">
					<v-toolbar
						color="primary"
						dark
						flat
					>
						<v-toolbar-title>Iniciar sesión</v-toolbar-title>
					</v-toolbar>
					<v-card-text>
						<v-form>
							<v-text-field
								label="Dirección de correo electrónico"
								prepend-icon="mdi-at"
								type="email"
								v-model="correo"
								@keypress.enter="acceder"
							></v-text-field>
							<v-text-field
								label="Contraseña"
								prepend-icon="mdi-lock-reset"
								type="password"
								minlenght="6"
								v-model="contraseña"
								@keypress.enter="acceder"
							></v-text-field>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							:loading="cargando"
							:disabled="desactivado"
							@click="acceder"
						>
							Ingresar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
import { autenticación } from '@/../../cliente_comun/fuentes'

export default {
	name: 'IniciarSesion',
  data: () => ({
		autenticación: autenticación,
		correo: '',
		contraseña: '',
	}),
	computed: {
		desactivado: function () {
			return !this.correo || !this.contraseña
		},
		cargando: function () {
			return this.autenticación.autenticando || this.autenticación.cargandoUsuario
		}
	},
	methods: {
		acceder: function() {
			autenticación.acceder(this.correo, this.contraseña)
		}
	}
}
</script>